import { UserInterface } from 'shared/types/user-interface'

export const getAvatarUrl = (dashboardUser?: UserInterface): string | undefined =>
  dashboardUser?.subaccountsAvatarUrls[dashboardUser?.id]
